export default function (Alpine) {
    Alpine.store('mobileMenu', {
        open: false,
        toggle() {
            this.open = !this.open
            document.body.classList.toggle('overflow-hidden', this.open)
        },
        openMenu() {
            this.open = true
            document.body.classList.add('overflow-hidden')
        },
        close() {
            this.open = false
            document.body.classList.remove('overflow-hidden')
        }
    })
}
